import React, { Component } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import NumberFormat from 'react-number-format';
import logoGoogle from '../images/google.png';
import logoApple from '../images/apple.png';
import { Redirect } from 'react-router-dom';

import { transactionID } from "../services/helpers";



class numero extends Component {


  constructor(props) {
    super(props);
    this.state = {
      storeToken: {},
      number: '',
      accessToken: '',
      code: '',
      form1: true,
      form2: false,
      form3: false,
      opacity1: false,
      opacity2: false,
      opacity3: false,
      redirect: false,
      isSendingSms: false,
      tokenCard: ""
    }
  };


  validatePhone = (event) => {
    event.preventDefault();
    this.setState({ opacity1: true });
    axios.post(`https://www.pagtel.com.br/Hub360Correios/auth/v1/validatePhone`, {
      Network: "Correios",
      MSISDN: "55" + this.state.number,
      Version: "0.1",
      UniqueID: "xxxxx",
      OS: "Navegador",
      SystemVersion: "0.1",
      Model: "PC",
      Source: "Site"
    })
      .then(res => {
        // console.log(res);
        // console.log(res.data);
        if (res.data.code === "04") {
          this.setState({
            accessToken: res.data.accessToken,
            storeToken: res.data
          });
          this.sendSMS();
        }
        else if (res.data.code === "00") {
          this.setState({
            accessToken: res.data.accessToken,
            storeToken: res.data,
            form1: false,
            form2: true
          });

          this.sendSMS('1');
        }
        else {
          Swal.fire(
            'Erro!',
            res.data.msg,
            'error'
          )
          this.setState({ opacity1: false });
        }
      })
      .catch(res => {
        Swal.fire(
          'Erro!',
          "Não foi possível conectar com o servidor!",
          'error'
        )
      })
  };

  backAll = () => {
    this.setState({
      form1: true,
      form2: false,
      form3: false
    });
  }

  sendSMS = (turne = "1") => {
    this.setState({
      isSendingSms: true
    })
    axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/sendSMS`, {
      transactionID:  transactionID('AAK'),
      MSISDN: "55"+this.state.number,
      text: "Seu Token de Acesso ao site é:",
      tokenValidate: "true"
    }, { headers: { "Authorization": "Bearer " + this.state.accessToken } })
      .then(res => {
        console.log(res.data);
        if (res.data.code === "P00") {
          this.setState({
            form1: false,
            form2: true,
            form3: false
          });

          let client = {
            accessToken: this.state.storeToken.accessToken,
            refreshToken: this.state.storeToken.refreshToken,
            number: "55" + this.state.number
          }

          localStorage.setItem('clientInfo', JSON.stringify(client));

          if (turne === "2") {
            Swal.fire(
              'Sucesso!',
              "Reenviado com sucesso!",
              'success'
            )
          }
        }
        else {
          Swal.fire(
            'Erro!',
            res.data.msg,
            'error'
          )
        }
      })
      .catch(res => {
        Swal.fire(
          'Erro!',
          "Não foi possível conectar com o servidor!",
          'error'
        )
      }).finally(() => {
        this.setState({
          isSendingSms: false
        })
      })
  };

  ValidateSMSToken = (event) => {
    event.preventDefault();
    this.setState({ opacity2: true });


    axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/ValidateSMSToken`, {
      transactionID: transactionID('AAL'),
      MSISDN: "55" + this.state.number,
      value: this.state.code
    }, { headers: { "Authorization": "Bearer " + this.state.accessToken } })
      .then(res => {
        console.log(res.data);
        if (res.data.code === "P00") {
          console.log(res.data);
          this.setState({ redirect: true });
          this.CheckPlanoInteligente();

        }
        else {
          Swal.fire(
            'Erro!',
            res.data.msg,
            'error'
          )
        }
        this.setState({ opacity2: false });
      })
      .catch(res => {
        Swal.fire(
          'Erro!',
          "Não foi possível conectar com o servidor!",
          'error'
        )
      })
  };

  CheckPlanoInteligente = () => {
    axios.post(`https://www.pagtel.com.br/Hub360Correios/v1/checkPlanoInteligente`, {
      transactionId: transactionID('AAM'),
      msisdn: "55" + this.state.number
    }, { headers: { "Authorization": "Bearer " + this.state.accessToken } })
      .then(res => {
        if (res.data.code == "P00") {
          localStorage.setItem('clientInfo', JSON.stringify({
            accessToken: this.state.storeToken.accessToken,
            isIntelligentControl: true,
            valuePlan: res.data.value,
            refreshToken: this.state.storeToken.refreshToken,
            number: "55" + this.state.number
          }));

        }
        else {
          localStorage.setItem('clientInfo', JSON.stringify({
            accessToken: this.state.storeToken.accessToken,
            isIntelligentControl: false,
            valuePlan: res.data.value,
            refreshToken: this.state.storeToken.refreshToken,
            number: "55" + this.state.number
          }));
        }

      })
      .catch(res => {
        Swal.fire(
          'Erro!',
          "Não foi possível conectar com o servidor!",
          'error'
        )
        this.setState({ opacity1: false });
      })
  }

  validateCard = (event) => {
    event.preventDefault();

    if (this.state.tokenCard == "") {
      Swal.fire(
        'Erro',
        "Preencha o campo!",
        'error'
      )
      return;
    }

    this.setState({ opacity3: true });

    axios.post(`https://www.pagtel.com.br/Hub360Correios/v1/cardValidate`, {
      transactionId: transactionID('AAN'),
      msisdn: "55" + this.state.number,
      token: this.state.tokenCard
    }, { headers: { "Authorization": "Bearer " + this.state.accessToken } })
      .then(res => {
        if (res.data.code == "P00") {
          if (res.data.isValid == "True") {
            let client = {
              accessToken: this.state.storeToken.accessToken,
              refreshToken: this.state.storeToken.refreshToken,
              number: "55" + this.state.number
            }

            localStorage.setItem('clientInfo', JSON.stringify(client));
            setTimeout(() => {
              this.setState({ redirect: true });
              this.CheckPlanoInteligente();
            }, 500)
          }
          else {
            Swal.fire(
              'Código Errado',
              "digite novamente!",
              'error'
            )
            this.setState({ opacity3: false });

          }
        }
        else {
          Swal.fire(
            'Erro!',
            res.data.msg,
            'error'
          )
          this.setState({ opacity3: false });
        }

      })
      .catch(res => {
        Swal.fire(
          'Erro!',
          "Não foi possível conectar com o servidor!",
          'error'
        )
        this.setState({ opacity1: false });
      })
  }

  callTo = () => {
    Swal.fire(
      'Ligue para:',
      '*290'
    )
  };

  goToCardStep = () => {
    this.setState({
      form1: false,
      form2: false,
      form3: true,
    })
  }

  render() {

    if (this.state.redirect) {
      return <Redirect to={{
        pathname: "/Recarga",
        state: {
          accessToken: this.state.accessToken,
          number: this.state.number
        }
      }} />
    }

    const opacity1 = this.state.opacity1 ? 'opacity' : '';
    const opacity2 = this.state.opacity2 ? 'opacity' : '';
    const opacity3 = this.state.opacity3 ? 'opacity' : '';

    const form1 = this.state.form1 ? 'show' : 'hide';
    const form2 = this.state.form2 ? 'show' : 'hide';
    const form3 = this.state.form3 ? 'show' : 'hide';
    return (
      <div className="content-right--main">
        <div className={form1}>
          <h3>FAÇA SUA RECARGA AQUI!</h3>

          <p>INSIRA O SEU NÚMERO COM DDD</p>
          <form onSubmit={this.validatePhone}  className="content-right--main-inputs">
            <label htmlFor="number">Número</label>

            <NumberFormat id="number"
              onValueChange={(values) => {
                const { value } = values;
                this.setState({ number: value })
              }}
              value={this.state.number} format="(##) #####-####" />

            <input type="submit" value="Continuar" className={`content-right--main-inputs-btn ${opacity1}`} />
          </form>
          <div className="content-right--footer">
            <p>Você também pode recarregar pelo nosso app:</p>
            <div className="content-right--footer-img">
              <a href="https://play.google.com/store/apps/details?id=br.com.correios.android.correioscelular" target="_blank">
                <img src={logoGoogle} alt="" />
              </a>
              <a href="https://apps.apple.com/br/app/correios-celular/id1339687909" target="_blank">
                <img src={logoApple} alt="" />
              </a>
            </div>
          </div>
        </div>
        <div className={form2}>
          <h3>ENVIAMOS UM CÓDIGO <br />
          DE VERIFICAÇÃO ;) </h3>
          <p>Digite o código de acesso<br />
          Que te enviamos via SMS</p>
          <form onSubmit={this.ValidateSMSToken} className="content-right--main-inputs">
            <label htmlFor="number">Código</label>

            <NumberFormat id="number"
              onValueChange={(values) => {
                const { value } = values;
                this.setState({ code: value })
              }}
              value={this.state.code} format="####" />

            <input disabled={this.state.isSendingSms} type="submit" value="Continuar" className={`content-right--main-inputs-btn-code ${opacity2}`} />
          </form>

          <div className="btn-back-page">
              
              <a  onClick={() => {
                this.setState({
                  form1: true,
                  form2: false,
                  form3: false,
                  opacity1: false,
                  opacity2: false,
                  opacity3: false,
                  code: '',
                  number: ''
                });
              }} >Voltar</a>
          </div>
          
          <div className="content-right--footer footer2">
            <p onClick={() => this.sendSMS('2')} >Reeviar código de acesso</p>
            <p onClick={this.callTo}>Você também pode solicitar<br />
              o código por <strong>telefone</strong></p>
            <p onClick={this.goToCardStep}>Ou digitar os 4 últimos digitos de seu cartão cadastrado.</p>
          </div>
        </div>
        <div className={form3}>
          <h3>CONFIRMAÇÃO TITULARIDADE</h3>
          <p>Para continuar informe os últimos 4 dígitos do cartão cadastrado</p>
          <form onSubmit={this.validateCard} className="content-right--main-inputs">
            <label htmlFor="number">4 Últimos dígitos</label>

            <NumberFormat id="number"
              onValueChange={(values) => {
                const { value } = values;
                this.setState({ tokenCard: value })
              }}
              value={this.state.tokenCard} format="####" />

            <input type="submit" value="Validar" className={`content-right--main-inputs-btn-code ${opacity3} ${this.state.isSendingSms ? 'opacity' : ''}`} />
          </form>
          <div className="content-right--footer footer2">
            <p>Caso queira, você também pode digitar o código de acesso recebido em seu celular.
              </p>
            <p onClick={() => this.sendSMS('1')} >Receber código de acesso</p>
            <p onClick={this.backAll}>Alterar telefone</p>
          </div>
        </div>

      </div>
    )
  }


}

export default numero; // Don’t forget to use export default!